import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'

export function Modal({
  title,
  children,
  onClose,
  footer,
}: {
  title: string
  children: ReactNode
  onClose: () => void
  footer?: ReactNode
}) {
  const { t } = useTranslation()
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[color:var(--stryzh-overlay-scrim-modal)]">
      <div
        role="dialog"
        className="stryzh-panel max-h-[var(--stryzh-layout-modal-max-height)] w-full max-w-[var(--stryzh-layout-modal-max-width)] overflow-auto"
      >
        <div className="flex items-center justify-between px-[var(--stryzh-space-6)] pb-[var(--stryzh-space-3)] pt-[var(--stryzh-space-5)]">
          <h2 className="font-[family-name:var(--stryzh-font-family-space-grotesk)] text-[length:var(--stryzh-font-size-lg)] font-semibold tracking-[var(--stryzh-letter-spacing-space-grotesk)] text-[color:var(--stryzh-color-text-primary)]">
            {title}
          </h2>
          <Button
            variant="ghost"
            onClick={onClose}
            aria-label={t('common.close')}
            className="stryzh-btn--close-icon"
          >
            ✕
          </Button>
        </div>
        <div className="px-[var(--stryzh-space-6)] py-[var(--stryzh-space-3)]">
          {children}
        </div>
        {footer ? (
          <div className="flex justify-end gap-2 px-[var(--stryzh-space-6)] pb-[var(--stryzh-space-5)] pt-[var(--stryzh-space-3)]">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  )
}
